import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerified = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 15,
		cy: 15,
		r: 15,
		fill: "#59B300"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10 14.8249L13.5876 18.4125L20 12",
		stroke: "white",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgVerified;
